import { goBack, push, replace } from 'connected-react-router';
import { createAction } from 'redux-actions';
import { map } from 'lodash';
import copyToClipboard from 'copy-to-clipboard';

import { openModalDialog, closeModalDialog } from '@nextiva/crm-modals';
import { showSuccessNotification, showWarningNotification } from '@nextiva/engagement-ui';

import { getModalsState } from 'reducers';

import Constants from 'constants/actions';
import modalTypes from 'constants/AppModalTypes';

export const setUser = createAction(Constants.SET_USER);

export const setAccessErrorType = createAction(Constants.SET_ACCESS_ERROR_TYPE);

export const navigate = (path) => push(path);

export const replaceRoute = (path) => replace(path);

export const handleBackButtonClick = () => goBack();

export const copyToClipboardAndNotify = (stringToCopy, successMessage = '', failMessage = '') => (
  dispatch,
) => {
  if (copyToClipboard(stringToCopy)) {
    dispatch(showSuccessNotification(successMessage));
  } else {
    dispatch(showWarningNotification(failMessage));
  }
};

export const copyLinkToClipboard = (url) => (dispatch) => {
  dispatch(
    copyToClipboardAndNotify(
      url,
      'Your link was successfully copied.',
      'Unable to copy the link, please do it manually.',
    ),
  );
};

export const openApplicationErrorModal = ({
  list = [],
  heading = 'Please correct the following:',
  title = 'Oops, there is an error',
  okButtonText = 'Ok',
}) =>
  openModalDialog({
    type: modalTypes.applicationError,
    title,
    heading,
    list,
    okButtonText,
  });

// @todo: this action should ideally be imported from crm-modals package @apavlosiuk
export const closeAllModalDialogs = () => (dispatch, getState) => {
  const modalDialogIds = map(getModalsState(getState()), 'dialogId');

  modalDialogIds.forEach((dialogId) => {
    dispatch(closeModalDialog(dialogId));
  });
};

export const handleHistoryLocationChange = () => (dispatch) => {
  dispatch(closeAllModalDialogs());
};

export const setFeatureFlag = createAction(Constants.SET_FEATURE_FLAG);
